import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-legacy-device-note',
  templateUrl: './legacy-device-note.component.html',
  styleUrls: ['./legacy-device-note.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegacyDeviceNoteComponent {
  @Input() header: string;
  @Input() isHeaderInside = false;
}
